module.exports = __webpack_public_path__ + "static/media/business-people1.7796accf.png";